import { UIBooker, UIFlightData, UIProductSelection } from "@flights/types";
import { flightsLocalStore } from "@flights/web-api-utils-universal";

export type SessionStorageOfferProperties = {
  ancillaries: UIProductSelection;
  /* start - flights_web_checkout_back_navigation */
  paxData: {
    passengers: Array<unknown>;
    booker: UIBooker;
  };
  /* end - flights_web_checkout_back_navigation */
};
type SessionStorageOfferData = Partial<SessionStorageOfferProperties>;
export type SessionStorageOfferToken = UIFlightData["token"];
type SessionStorageOffer = Partial<Record<SessionStorageOfferToken, SessionStorageOfferData>>;

const key = "offers_checkout_data";
const expirationTime = "30m";

const getSessionStorageData = () => (flightsLocalStore.get(key) || {}) as SessionStorageOffer;

export const getOfferCheckoutData = (offerToken: SessionStorageOfferToken) =>
  getSessionStorageData()[offerToken] || undefined;

type UpdateFn = (currentState: SessionStorageOfferData) => Partial<SessionStorageOfferData>;

export const setOfferCheckoutData = (
  offerToken: SessionStorageOfferToken,
  stateOrUpdateFn: SessionStorageOfferData | UpdateFn
) => {
  const storeData = getSessionStorageData();

  if (typeof stateOrUpdateFn === "function") {
    const currentData = getOfferCheckoutData(offerToken) || {};
    storeData[offerToken] = stateOrUpdateFn(currentData);
  } else {
    storeData[offerToken] = stateOrUpdateFn;
  }

  flightsLocalStore.set(key, storeData, { ttl: expirationTime });
};
